import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

const useAuctionItemFiltersRestoration = (setOptions: any, options: any) => {
    const pathname = usePathname();
    const [isRestored, setIsRestored] = useState(false);

    // ✅ Save filter selections when they change
    useEffect(() => {
        if (!isRestored) {
            const savedFilters = sessionStorage.getItem(`filters-${pathname}`);

            if (savedFilters) {
                const parsedFilters = JSON.parse(savedFilters);

                setOptions((prevOptions: any) => {
                    if (JSON.stringify(parsedFilters) === JSON.stringify(prevOptions.filtering.selections)) {
                        return prevOptions; // ✅ Prevents unnecessary re-renders
                    }
                    return {
                        ...prevOptions,
                        filtering: {
                            ...prevOptions.filtering,
                            selections: parsedFilters,
                        },
                    };
                });
            }

            setIsRestored(true);
        }

    }, [pathname, setOptions, isRestored]);

    useEffect(() => {
        if (isRestored) {
            sessionStorage.setItem(`filters-${pathname}`, JSON.stringify(options.filtering.selections));
        }
    }, [pathname, options?.filtering?.selections, isRestored]);

    return;
};

export default useAuctionItemFiltersRestoration;